// The supplier database as spreadsheet rows (Suppliers page → Export to Excel). Plain data, no page access, so tests
// can check it on its own.
export const SUPPLIER_COLUMNS = [
  ['Supplier', 30], ['Category', 26], ['City', 16], ['Area', 16], ['Contact', 20], ['Email', 30], ['Phone', 18], ['Website', 30],
  ['VAT / tax ID', 16], ['Rating', 8], ['Preferred', 10], ['Description', 44], ['Internal notes', 44], ['In tenders', 11], ['Awarded', 9],
  ['Added by', 12], ['Last edited', 12]
];
const day = t => t ? new Date(t).toISOString().slice(0, 10) : '';
// suppliers: as on the page; catName(key) → category name; usage(name) → the briefs that supplier is in
export function supplierRows(suppliers, catName, usage) {
  return suppliers.map(s => {
    const u = usage(s.name) || [];
    return [s.name || '', catName(s.cat), s.city || '', s.area || '', s.contact || '', s.email || '', s.phone || '', s.web || '',
      s.taxId || '', Number(s.rating) || '', s.preferred ? 'Yes' : '', s.note || '', s.notes || '', u.length || '',
      u.filter(x => x.status === 'Awarded').length || '', s.src === 'ai' ? 'Claude (Tenders)' : s.src === 'built-in' ? 'Built-in list' : s.editedBy || 'By hand',
      day(s.editedAt || s.addedAt)];
  });
}
